import { render, staticRenderFns } from "./ModeratorEnableLocation.vue?vue&type=template&id=8090ad5e&"
import script from "./ModeratorEnableLocation.vue?vue&type=script&lang=js&"
export * from "./ModeratorEnableLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports